import React from "react";
import Home from "./Components/Home";
import About from "./Components/About";
import Contact from "./Components/Contact";
import { Routes, Route } from "react-router-dom";
import Services from "./Components/Services";
import Articles from "./Components/Articles";
import ArticleDetail from "./Components/ArticleDetail";
import MovingAvg from "./Components/MovingAvg";
import Macd from "./Components/Macd";
import Rsi from "./Components/Rsi";
import Paisa from "./Components/Paisa";
import AdminLogin from "./Components/AdminLogin";
import AdminDashboard from "./Components/AdminDashboard";

const Routing = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/home" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/services" element={<Services />} />
      <Route path="/articles" element={<Articles />} />
      <Route path="/article/:id" element={<ArticleDetail />} />
      <Route path="/movingavg" element={<MovingAvg />} />
      <Route path="/macd" element={<Macd />} />
      <Route path="/rsi" element={<Rsi />} />
      <Route path="/paisa" element={<Paisa />} />
      {/* Admin Routes */}
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin/dashboard" element={<AdminDashboard />} />
    </Routes>
  );
};

export default Routing;